/**
 * Asks the canvas's DropZone to upload files, the same way as a drop: for
 * pastes that arrive outside a paste event (the canvas menu's Paste reads
 * the clipboard itself). `at` is a point on screen; without it the files
 * land in the middle of the visible canvas.
 */
export const UPLOAD_REQUEST_EVENT = 'mindfull:upload-files';

export interface UploadRequest {
  files: File[];
  at?: { clientX: number; clientY: number };
}

export function requestUpload(files: File[], at?: UploadRequest['at']): void {
  if (!files.length) return;
  window.dispatchEvent(new CustomEvent<UploadRequest>(UPLOAD_REQUEST_EVENT, { detail: { files, at } }));
}
